import {
  DeleteButton,
  EditButton,
  List,
  TextField,
  useTable,
} from '@refinedev/antd'
import { CrudFilters, HttpError, useNavigation } from '@refinedev/core'
import { Button, Input, Space, Table } from 'antd'
import { TableSearchInput } from 'components/input/TableSearchInput'
import { ICourse } from 'interfaces/catering'
import { COURSE_URL } from 'urls'
import { getSearchFormInitialValue } from 'utils/filter'

export const CourseList: React.FC = () => {
  const { tableProps, searchFormProps, filters } = useTable<ICourse>({
    onSearch: (params) => {
      const filters: CrudFilters = []
      //@ts-ignore
      const { search } = params ?? {}
      if (search) {
        filters.push({
          field: 'search',
          operator: 'eq',
          value: search,
        })
      }
      return filters
    },
    syncWithLocation: true,
  })

  const { create, edit } = useNavigation()

  return (
    <List
      headerButtons={() => (
        <>
          <TableSearchInput
            searchFormProps={searchFormProps}
            intialValues={getSearchFormInitialValue(filters)}
          />
          <Button type="primary" onClick={() => create(COURSE_URL)}>
            Create Course
          </Button>
        </>
      )}>
      <Table {...tableProps} rowKey="id" size="small">
        <Table.Column key="id" dataIndex="id" title="ID" />
        <Table.Column<ICourse>
          key="title"
          dataIndex="name"
          title="Name"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column<ICourse>
          title="Actions"
          dataIndex="actions"
          key="actions"
          render={(_, record) => (
            <Space>
              <Button size="small" onClick={() => edit(COURSE_URL, record.id)}>
                Edit
              </Button>
              <DeleteButton
                size="small"
                resource={COURSE_URL}
                recordItemId={record.id}
              />
            </Space>
          )}
        />
      </Table>
    </List>
  )
}
